
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
computed: {
userInfo() {
return this.$store.state.userInfo
},
shopInfo() {
return this.$store.state.shopInfo
}
},
components: {
Actionsheet,
Group,
Cell
},
data() {
return {
show1: false,
menus1: {
"400-706-2525": "电话： 400-706-2525",
"kuaimaijiu8": '微信号 kuaimaijiu8'
}
}
},
methods: {
click(key) {
console.log(key);
if(key=='400-706-2525'){
window.location.href = "tel:400-706-2525"
}else{

}
}
}
}





// WEBPACK FOOTER //
// ./src/components/UserCenter/BtmNav.vue